// extracted by mini-css-extract-plugin
export default {"formBody":"GenerateLead_formBody__p-zlG"};